import request, { REQUEST_METHODS } from '@api/Request';
import { GeospatialEndpoints } from './config';
import { AddressSuggestionsResponse, GeocodeResponse, GeometryResponse, ReverseGeocodeResponse } from './types';

const DEFAULT_LOCATION = '-77.0364,38.8951'; // Default to Washington, DC if no location is provided

export default class GeospatialService {
  public static readonly getAddressCandidates = (address: string, magicKey?: string): Promise<GeocodeResponse> =>
    request({
      url: GeospatialEndpoints.getAddressCandidates(),
      method: REQUEST_METHODS.GET,
      params: {
        singleLine: address,
        category: 'Point Address,Subaddress',
        magicKey,
        outFields: '*',
        f: 'json',
      },
      skipAuth: true,
    });
  public static readonly getSuggest = (
    text: string,
    location: string,
    usOnly: boolean
  ): Promise<AddressSuggestionsResponse> =>
    request({
      url: GeospatialEndpoints.getSuggest(),
      method: REQUEST_METHODS.GET,
      params: {
        text,
        location: location || DEFAULT_LOCATION, //Default to Washington, DC if no location is provided
        category: 'Address',
        countryCode: usOnly ? 'USA,ASM,PRI,UMI,VIR,GUM,FSM' : undefined,
        f: 'json',
      },
      skipAuth: true,
    });
  public static readonly getReverseGeocode = (location: string, local: boolean): Promise<ReverseGeocodeResponse> =>
    request({
      url: GeospatialEndpoints.getReverseGeocode(),
      method: REQUEST_METHODS.GET,
      params: {
        location,
        f: 'json',
        local,
      },
    });
  public static readonly getGeometryData = async (
    gdbFile: File,
    firstPolygonOnly: boolean
  ): Promise<GeometryResponse> => {
    const formData = new FormData();
    formData.append('data', gdbFile);
    formData.append('firstPolygonOnly', firstPolygonOnly.toString());
    return await request({
      url: GeospatialEndpoints.getGeometryData(),
      method: REQUEST_METHODS.POST,
      headers: { 'Content-Type': 'application/x-zip-compressed' },
      data: formData,
    });
  };
}
